import React, { useEffect } from "react"
import { useWizard } from "../../../../components/wizard/WizardContext"
import { dropdownMapping, fetchAllPostPromisedData, fetchAllPromisedData } from "../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "../../../../views/pages/manage/common/constant";
import { CourseDetailsPopupById } from "../../../../views/pages/manage/unAssigned/studentCharges/common";
import { IoEyeOutline } from "react-icons/io5";
import { Tooltip } from "@mui/material";
import SecurityRefundItem from "./selectRefundItems/refundItems/SecurityRefundItem";
import DiscretionaryRefundItem from "./selectRefundItems/refundItems/DiscretionaryRefundItem";
import WithdrawalRefundItem from "./selectRefundItems/refundItems/WithdrawalRefundItem";
import ConcessionRefundItem from "./selectRefundItems/refundItems/ConcessionRefundItem";
import FullRefund from "./selectRefundItems/refundItems/FullRefund";
import { fetchStudentSummary } from "modules/studentTransfer/apis";
import moment from "moment";
import { getFormatedDate } from "../../../../views/pages/manage/unAssigned/concessionApproval/common";

export const accordionStyles = {
    border: '2px solid #E2E2E2',
    borderRadius: '16px',
    marginBottom: '1rem',
    '&:before': { height: '0px' },
}

//multi-type refund sub-types enums
export const SECURITY_REFUND = 'SECURITY_REFUND';
export const DISCRETIONARY_REFUND = 'DISCRETIONARY_REFUND';
export const WITHDRAWAL_REFUND = 'WITHDRAWAL_REFUND';
export const CONCESSION_REFUND = 'CONCESSION_REFUND';
export const FULL_REFUND = 'FULL_REFUND';


//beneficiary enums
export const STUDENT = 'STUDENT';
export const LOAN = 'LOAN'

//attachment enums
export const PARENT_ATTACHMENT = 'PARENT_ATTACHMENT';
export const LOAN_ATTACHMENT = 'LOAN_ATTACHMENT';

export const CHEQUE_PAYMENT_MODE_KEY = 'CHKL';

export const REFUND_VALIDATIONS_BYPASS_ROLES = ['REFUND_MASTER'];

export const refundItemsInfoMap = {
    [SECURITY_REFUND]: { component: SecurityRefundItem, label: 'Security Refund' },
    [DISCRETIONARY_REFUND]: { component: DiscretionaryRefundItem, label: 'Discretionary Refund' },
    [WITHDRAWAL_REFUND]: { component: WithdrawalRefundItem, label: 'Withdrawal Refund' },
    [CONCESSION_REFUND]: { component: ConcessionRefundItem, label: 'Concession Refund' },
    [FULL_REFUND]: { component: FullRefund, label: 'Full Refund' },
};

export const DLP_ITEMS = [
    {label : 'Books' , value : 'books'},
    {label : 'AIATS' , value : 'AIATS'},
    {label : 'Online Tests' , value : 'onlineTests'},
]

const refundItemEmptyForm = {
    reason: "",
    remarks: "",
    payableToParent: "",
    payableToVendor: "",
    parentAttachmentKey: "",
    loanAttachmentKey: ""
}

// const dlpItemsEmptyForm = {
//     refundPercentage: 0,
//     itemsFee: 0,
//     totalQty: 0,
//     perUnitCost: 0,
//     qtyUtilised: 0,
//     qtyRemaining: 0,
//     utilisedAmount: 0
// }

export const multiTypeRefundDetailsEmptyForm = () => {
    let obj = {}
    Object.keys(refundItemsInfoMap).forEach(refundItem => {
        obj = {
            ...obj,
            [refundItem]: { ...refundItemEmptyForm }
        }
    })

//     obj.dlpWithdrawalRefundDetails = {};

//    DLP_ITEMS.forEach(item => {
//     obj = {
//         ...obj,
//         dlpWithdrawalRefundDetails : {
//            ...obj.dlpWithdrawalRefundDetails,
//            [item.value] : {...dlpItemsEmptyForm}
//         }
//     }
//    })

    return obj;
}

export const fetchStudentSecurityCourseId = async (applicationId) => {
    const allOtherCharges = await fetchAllPromisedData(`${endpoint.otherChargesConcession.getAllOtherCharegesById}/${applicationId}`);
    const securityCharge = allOtherCharges?.find(charge => charge?.itemType?.slice(-2) === "12");
    return (securityCharge?.courseId ?? null);
}

export const fetchCoursePricingDetails = async ({businessArea, courseId, term}) => {
    const req = { businessArea, courseId, term };
    const resp = await fetchAllPostPromisedData(`${endpoint.course.getCoursePricingDetails}`, req);
    if (resp?.code === 200) {
        return resp?.data;
    }

    return {};
}

const getFeeBreakupWithTax = async (studentDetails) => {

    const { courseId, term, businessArea } = studentDetails;
    const reqObj = {
        courseId,
        termId: term,
        businessAreaId: businessArea,
        isInterStateTxn: false
    }

    const resp = await fetchAllPostPromisedData(endpoint.breakup.getFeeBreakupWithTax, reqObj);
    return resp?.data;
}

export const useGetAdditionalStudentDetails = (setLoading, handleRefundDetailsForm) => {

    const { values, setValues } = useWizard();
    const { selectedStudent, multiTypeRefundStep2Data } = values;
    const { applicationId, businessAreaDispVal } = selectedStudent;
    const { additionalStudentDetails } = multiTypeRefundStep2Data;

    const setAdditionalStudentDetails = details => {
        setValues(vals => {
            return {
                ...vals,
                multiTypeRefundStep2Data: {
                    ...vals?.multiTypeRefundStep2Data,
                    additionalStudentDetails: details
                }
            }
        })
    }


    const fetchStudentFeeBreakup = async () => {
        const resp = await fetchStudentSummary(applicationId, businessAreaDispVal);
        return resp?.data;
    }

    const fetchStudentDetails = async () => {
        try {
            setLoading(true);

            let studentLoanDetails = { isLoanCase: false };

            const [
                // applicationQuotationDetails,
                doDetails,
                studentChargesDetails,
                securityCourseId,
                coursePricingDetails,
                studentFeeBreakup,
                feeBreakupWithTaxDetails,
            ] = await Promise.all([
                fetchAllPromisedData(`${endpoint.deliveryOrder.deliveryOrderDetails}?application=${applicationId}`),
                // fetchAllPromisedData(`${endpoint.applicationQuotationDetails}/${applicationId}`),
                fetchAllPromisedData(`${endpoint.getStudentChargesApplicationDetails}/${applicationId}/STUDENT_CHARGES`),
                fetchStudentSecurityCourseId(applicationId),
                fetchCoursePricingDetails(selectedStudent),
                fetchStudentFeeBreakup(),
                getFeeBreakupWithTax(selectedStudent)
            ]);


            // const { loanSchemeMasterId, cashierOffice } = applicationQuotationDetails;

            // if (loanSchemeMasterId != null) {
            if(doDetails){

                // const { applicationQuotationDetailsId: latestQuotationId } = studentChargesDetails;
                // const doDetails = await fetchAllPromisedData(`${endpoint.deliveryOrder.deliveryOrderDetails}/${latestQuotationId}`);
                const {loanSchemeMasterId} = doDetails;
                const allLoanSchemes = await fetchAllPromisedData(`${endpoint.loanScheme}/all`);
                const appliedLoanScheme = allLoanSchemes?.find(scheme => scheme?.id === loanSchemeMasterId);

                studentLoanDetails = {
                    isLoanCase: true,
                    loanScheme: appliedLoanScheme,
                    loanAmount: doDetails?.grossLoanAmount,
                    doId: doDetails?.doId,
                    netLoanAmount: doDetails?.netLoanAmount,
                    totalUpfrontPaymentByParent: doDetails?.totalUpfrontPaymentByParent

                };
            }

            setAdditionalStudentDetails({
                // cashierOffice,
                securityCourseId,
                studentLoanDetails,
                coursePricingDetails,
                studentChargesDetails,
                studentFeeBreakup,
                feeBreakupWithTaxDetails
            });

            handleRefundDetailsForm("batchEndDate", coursePricingDetails?.courseEndDate)

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }


    useEffect(() => {
        !additionalStudentDetails && fetchStudentDetails();
    }, [])
}

const updateLoanVendorAccountDetails = data => {
    return data?.map(el => {
        const { countryCode, ifsc, status } = el;
        return {
            ...el,
            country: countryCode,
            ifscCode: ifsc,
            bankStatus : status
        }
    })
}

export const useGetStudentAndVendorAccountDetails = (setLoading) => {

    const { values, setValues, updateValues } = useWizard();
    const { multiTypeRefundStep2Data } = values;
    const { additionalStudentDetails } = multiTypeRefundStep2Data;
    const { psid } = values?.selectedStudent || {};

    const setAdditionalStudentDetails = (details) => {
        setValues(vals => ({
            ...vals,
            multiTypeRefundStep2Data: {
                ...vals?.multiTypeRefundStep2Data,
                additionalStudentDetails: details
            }
        }));
    };

    const fetchAccountDetails = async (isLoanCase, loanScheme) => {
        const { payModeValue = "BFL" } = loanScheme ?? {};
        try {
            setLoading(true);
            const [studentAccountDetails, loanVendorDetailsResp = {}] = await Promise.all([
                fetchAllPromisedData(`${endpoint.studentBankDetails.getBankDetailsByPsid}/${psid}`),
                (isLoanCase && payModeValue ? fetchAllPostPromisedData(`${endpoint?.refund?.thirdPartyBankMaster?.search}?offset=${0}&pageSize=${50}`, { thirdPartyCodes: [payModeValue] }) : {})
            ])

            let loanVendorAccountDetails = [];

            if (loanVendorDetailsResp?.code === 200) {
                const data = loanVendorDetailsResp?.data?.paginatedData ?? [];
                loanVendorAccountDetails = updateLoanVendorAccountDetails(data);
            }
            setAdditionalStudentDetails({
                ...additionalStudentDetails,
                studentAccountDetails,
                loanVendorAccountDetails
            });

            // updateValues("multiTypeRefundStep3Data",
            //     {
            //         studentAccountDetails: studentAccountDetails?.map(el => ({ ...el, beneficiaryType: 'Student' })),
            //         loanVendorAccountDetails: loanVendorAccountDetails?.map(el => ({ ...el, beneficiaryType: 'Third Party' }))
            //     }
            // )

            setValues(vals => ({
                ...vals,
                multiTypeRefundStep3Data: {
                    ...vals?.multiTypeRefundStep3Data,
                    studentAccountDetails: studentAccountDetails?.map(el => ({ ...el, beneficiaryType: 'Student' })),
                    loanVendorAccountDetails: loanVendorAccountDetails?.map(el => ({ ...el, beneficiaryType: 'Third Party' }))
                }

            }))
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);

        }
    }

    useEffect(() => {
        const { studentLoanDetails } = additionalStudentDetails || {};
        if (studentLoanDetails) {
            const { isLoanCase, loanScheme } = studentLoanDetails;
            fetchAccountDetails(isLoanCase, loanScheme);
        }
    }, [psid, additionalStudentDetails?.studentLoanDetails]);

}

export const useGetMultiTypeRefundStep2Utils = () => {

    const { values, setValues } = useWizard();

    const { multiTypeRefundUtils } = values;
    const { refundReasons } = multiTypeRefundUtils;

    //refactor : we can have a common property in "values " for reasons of both rectification and multiType refunds 

    const setMultiTypeRefundUtils = (newVals) => {
        setValues(vals => {
            return {
                ...vals,
                multiTypeRefundUtils: {
                    ...vals?.multiTypeRefundUtils,
                    ...newVals
                }
            }
        })
    }


    const fetchRectificationReasons = async () => {
        try {
            setMultiTypeRefundUtils({ loading: true })

            const allReasons = await dropdownMapping(
                endpoint.refund.refundreason,
                "reasonDisplayValue",
                "id",
                "refundType"
            );

            const groupedReasons = allReasons?.reduce((acc, curr) => {

                const refundType = curr?.refundType
                acc[refundType] = [...(acc[refundType] ?? []), curr]

                return acc;

            }, {})

            // groupedReasons[DISCRETIONARY_REFUND] = [allReasons?.find(reason => reason?.label === 'Others')];
            // debugger

            setMultiTypeRefundUtils({ refundReasons: groupedReasons })

        } catch (err) {
            console.error(err);
        } finally {
            setMultiTypeRefundUtils({ loading: false })

        }

    }

    useEffect(() => {
        (!refundReasons) && fetchRectificationReasons();
    }, [])
}

export const fetchAllCountriesAndBanks = async () => {
    const resp = await Promise.all([
        dropdownMapping(
            endpoint.country.getAllActive,
            "countryDesc",
            "countryCode",
        ),
        fetchAllPostPromisedData(
            `${endpoint.bankMaster.search}?offset=-1`,
            {}
        )

    ]);

    const bankList = resp[1]?.data?.bankMasterList ?? [];
    const allBanks = bankList?.map(bank => ({ ...bank, label: bank?.bankName, value: bank?.id }));
    const allCountries = resp[0] ?? [];

    return {allCountries, allBanks};
}


export const useGetMultiTypeRefundStep3Utils = () => {

    const { values, setValues } = useWizard();

    const { multiTypeRefundUtils } = values;
    const { allCountries, allBanks } = multiTypeRefundUtils;

    const setMultiTypeRefundUtils = (newVals) => {
        setValues(vals => {
            return {
                ...vals,
                multiTypeRefundUtils: {
                    ...vals?.multiTypeRefundUtils,
                    ...newVals
                }
            }
        })
    }


    const fetchUtils = async () => {
        try {
            setMultiTypeRefundUtils({ loading: true })
            const resp = await fetchAllCountriesAndBanks();

            // const bankList = resp[1]?.data?.bankMasterList ?? [];
            setMultiTypeRefundUtils({
                // allCountries: resp[0],
                // allBanks: bankList?.map(bank => ({ ...bank, label: bank?.bankName, value: bank?.id })),
                ...resp
            })


        } catch (err) {
            console.error(err);
        } finally {
            setMultiTypeRefundUtils({ loading: false })

        }


    }

    useEffect(() => {
        (!allBanks || !allCountries) && fetchUtils();
    }, [])
}

const createGetPayableRefundInfoReq = (studentDetails, refundDetailsForm) => {

    const { psid, applicationId, businessArea, businessAreaDispVal, courseId, securityCourseId = null, academicCareerValue } = studentDetails;
    const { refundApplicationDate, batchStartDate, batchEndDate, loanOutstanding } = refundDetailsForm;

    return {
        psid,
        applicationId,
        academicCareer: academicCareerValue,
        businessArea: businessAreaDispVal,
        businessAreaId: businessArea,
        regularCourseId: courseId,
        securityCourseId,
        refundApplicationDate : getFormatedDate(refundApplicationDate, false, "YYYY-MM-DD"),
        batchStartDate : getFormatedDate(batchStartDate, false, "YYYY-MM-DD"),
        batchEndDate :  getFormatedDate(batchEndDate, false, "YYYY-MM-DD"),
        loanOutstandingAmount : loanOutstanding,
        refundDetails: [
            {
                subOrderType: FULL_REFUND,
                bifurcationRequired: true
            },
            {
                subOrderType: SECURITY_REFUND,
                bifurcationRequired: true
            },
            {
                subOrderType: WITHDRAWAL_REFUND,
                bifurcationRequired: true
            },
            {
                subOrderType: DISCRETIONARY_REFUND,
                bifurcationRequired: true
            },
            {
                subOrderType: CONCESSION_REFUND,
                bifurcationRequired: true
            },
        ]
    }

}

export const fetchPayableRefundInfo = async (...args) => {
    const req = createGetPayableRefundInfoReq(...args);
    const resp = await fetchAllPostPromisedData(endpoint.refund.multiTypeRefund.payableAmount, req);

    if (resp?.code === 200) {

        const { daysUsed, refundDetails } = resp?.data;

        const refundDetailsBySubOrderType = refundDetails?.reduce((acc, curr) => {

            const { subOrderType, payableDetails, totalRefundableAmount = 0, courseId, termValue, week, policyId , associatedRuleIds} = curr;

            acc[subOrderType] = {
                weekNumber : Number(week),
                policyId,
                associatedRuleIds,

                courseId,
                termValue,

                totalRefundableAmount,
                refundableAmountToParent: payableDetails?.find(el => el?.beneficiaryType == STUDENT)?.refundableAmount ?? 0,
                refundableAmountToLoanVendor: payableDetails?.find(el => el?.beneficiaryType == LOAN)?.refundableAmount ?? 0,
                "regRefundAmount":curr?.regRefundAmount || 0,
                "admRefundAmount": curr?.admRefundAmount  ||0,
                "cmprRefundAmount": curr?.cmprRefundAmount ||0
            }
            return acc;
        }, {}) ?? {}

        return {
            daysUsed,
            ...refundDetailsBySubOrderType
        }
    }
}

export const studentDetailsLabelFieldMapping = (studentDetails, dropdowns) => {

    const { courseId, businessArea } = studentDetails;
    const buDesc = dropdowns?.businessAres?.find(bu => bu?.value === businessArea)?.businessAreaDesc;

    return [
        { label: 'PSID', field: 'psid' },
        { label: 'Student Name', field: 'studentName' },
        { label: 'Application No', field: 'applicationId' },
        // {label : 'Parent Name', field : 'parentName'},
        {
            label: 'Regular Course Id',
            field: 'courseId',
            renderExtra: (
                <CourseDetailsPopupById courseId={courseId} placement="left-end" cta={<IoEyeOutline className='ml-2' />} />
            )
        },
        { label: 'Security Course Id', field: 'securityCourseId' },
        { label: 'Term', field: 'termDispVal' },
        { label: 'Career', field: 'academicCareerValue' },
        { label: 'Stream', field: 'academicGroupDispValue' },
        {
            label: 'Branch',
            field: 'businessAreaDispVal',
            renderExtra: (
                <Tooltip title={buDesc}>
                    <span className='ml-2'><IoEyeOutline /></span>
                </Tooltip>
            )
        },
        { label: 'Cashier Office', field: 'cashierOffice' },
    ]
}

const getInitMultiTypeRefundReq = ({ studentDetails, multiTypeRefundStep2Data, primaryStudentAccount, loanVendorAccount, isLoanCase, refundType, doId }) => {
    const {
        psid,
        applicationId,
        studentName,
        businessAreaDispVal,
        businessArea,
        termDispVal,
        term,
        academicGroupDispValue,
        academicGroup,
        courseId,
        academicCareerValue,
        cashierOffice,
        studentChargesDetails,
    } = studentDetails;

    const { selectedRefundItems, refundDetailsForm, payableRefundInfo, withdrawalFeeSummary, isDLPCase } = multiTypeRefundStep2Data;

    const { batchStartDate, batchEndDate, refundApplicationDate, preClosureReferenceNumber, preClosureReferenceDate, loanOutstanding, refundNumber = null, dlpWithdrawalRefundDetails = {}} = refundDetailsForm;
    
    const dlpFeeSummaryDto = {
        ...dlpWithdrawalRefundDetails,
        // dlpFeeSummaryBreakup : Object?.values((dlpWithdrawalRefundDetails??{}))?.filter(item => item?.utilisedAmount)
        dlpFeeSummaryBreakup : DLP_ITEMS?.map(item => dlpWithdrawalRefundDetails?.[item?.value])
    }



    return {

        psid,
        applicationId,
        studentName,
        businessAreaValue: businessAreaDispVal,
        businessArea,
        termValue: termDispVal,
        regularCourseId: courseId,
        orderType: refundType?.value,
        refund_status: "INPROGRESS",
        cashierOffice,
        refundNumber,
        fatherName: studentChargesDetails?.studentFatherName,
        academicCareerValue,

        refundDto: {
            batchStartDate : getFormatedDate(batchStartDate, false, "YYYY-MM-DD"),
            batchEndDate : getFormatedDate(batchEndDate, false, "YYYY-MM-DD"),
            applicationDate: getFormatedDate(refundApplicationDate, false, "YYYY-MM-DD"),
            preClosureReferenceDate: getFormatedDate(preClosureReferenceDate, false, "YYYY-MM-DD"),
            preClosureReferenceNumber,
            loanOutstanding,

            multiTypeRefundDetails: selectedRefundItems?.map(refundItem => {

                const { reason, remarks, payableToParent, payableToVendor, parentAttachmentKey, loanAttachmentKey, cmpConcession, admissionConcession, registrationConcession } = refundDetailsForm[refundItem];
                const { termValue, courseId,admRefundAmount,cmprRefundAmount, regRefundAmount   } = payableRefundInfo[refundItem];

                const numPayableToParent = +payableToParent;
                const numPayableToVendor = +payableToVendor;

                return {
                    refundType: refundItem,
                    orderReasonId: reason?.value,
                    term: termValue,
                    courseId,
                    remarks,
                    admRefundAmount : admissionConcession ? admissionConcession : 0,
                    cmprRefundAmount : cmpConcession ? cmpConcession : 0,
                    regRefundAmount : registrationConcession ? registrationConcession : 0,
                    refundAmount: (numPayableToParent) + (numPayableToVendor),
                    supportingDocument: [
                        ...(numPayableToParent ? [{
                            documentType: PARENT_ATTACHMENT,
                            s3Key: parentAttachmentKey
                        }] : []),

                        ...(numPayableToVendor ? [{
                            documentType: LOAN_ATTACHMENT,
                            s3Key: loanAttachmentKey
                        }] : []),
                    ],
                    paymentAccountDetails: [
                        ...(numPayableToParent
                            ? [
                                {
                                    beneficiaryType: STUDENT,
                                    paymentModeType: primaryStudentAccount?.paymentModeType || "EFT",
                                    bankMasterId: primaryStudentAccount?.bankMasterId,
                                    bankKey: primaryStudentAccount?.bankKey,
                                    paymentModeNumber: primaryStudentAccount?.accountNumber,
                                    accountType: primaryStudentAccount?.bankAccountType,
                                    ifscCode: primaryStudentAccount?.ifscCode,
                                    beneficiaryName: primaryStudentAccount?.beneficiaryName,
                                    supportingDocument : primaryStudentAccount?.attachmentKey,
                                    paymentModeDate : primaryStudentAccount?.paymentModeDate,
                                    refundableAmount: numPayableToParent
                                }
                            ] : []),
                        ...(numPayableToVendor
                            ? [
                                {
                                    beneficiaryType: LOAN,
                                    paymentModeType: "EFT",
                                    bankMasterId: loanVendorAccount?.bankMasterId,
                                    bankKey: loanVendorAccount?.bankKey,
                                    paymentModeNumber: loanVendorAccount?.accountNumber,
                                    // accountType: loanVendorAccount?.bankAccountType,
                                    ifscCode: loanVendorAccount?.ifscCode,
                                    beneficiaryName: loanVendorAccount?.beneficiaryName,
                                    refundableAmount: numPayableToVendor,
                                    preClosureReferenceNumber,
                                    preClosureReferenceDate: getFormatedDate(preClosureReferenceDate, false, "YYYY-MM-DD"),
                                    loanOutstanding,
                                    loanDoID : doId,
                                    thirdPartyCode : loanVendorAccount?.thirdPartyCode

                                }
                            ]
                            : [])

                    ],

                    ...(refundItem === WITHDRAWAL_REFUND
                        ? {
                            withdrawalFeeSummary,
                            ...(isDLPCase ? { dlpFeeSummaryDto } : {})
                        }
                        : {}
                    )

                }

            }),
        }
    }
}

export const initiateMultiTypeRefund = async ({forRefundEdit , ...argsObj}) => {
    const req = getInitMultiTypeRefundReq(argsObj);
    let url = forRefundEdit ? endpoint.refund.updateRefund : endpoint.refund.createRefund;
    return fetchAllPostPromisedData(url, req);

}

export const formatDate = (date) => date ? moment(date).format('DD/MM/YYYY') : ''

export const segregateRefundDetails = (details) => {
    const { subOrderType,regRefundAmount,admRefundAmount, cmprRefundAmount, refundAmount, rectificationReason, remark,
                
        attachments = [], orderReasonId, refundDto, refundNumber, createdOn } = details || {};

    const { paymentAccountDetails, multiTypeRefundDetails, withdrawalFeeSummary, dlpFeeSummaryBreakUpList = [], academicCareer } = refundDto ?? {};

    const loanAttachmentKey = attachments?.find(el => el?.documentType === LOAN_ATTACHMENT)?.s3Key ?? "";
    const parentAttachmentKey = attachments?.find(el => el?.documentType === PARENT_ATTACHMENT)?.s3Key ?? "";

    const studentPaymentDetails = paymentAccountDetails?.find(el => el?.beneficiaryType === STUDENT);
    const vendorPaymentDetails = paymentAccountDetails?.find(el => el?.beneficiaryType === LOAN);
    const isLoanCase = !!vendorPaymentDetails; //isLoanCase logic needs to be verified
    // const { preClosureReferenceNumber, preClosureReferenceDate, loanOutstanding } = vendorPaymentDetails ?? {};
    const { applicationDate, batchStartDate, batchEndDate, preClosureReferenceNumber, preClosureReferenceDate, loanOutstanding } = multiTypeRefundDetails || {};

    const loanLetterNumber = preClosureReferenceNumber ?? vendorPaymentDetails?.preClosureReferenceNumber;
    const loanLetterDate = preClosureReferenceDate ?? vendorPaymentDetails?.preClosureReferenceDate;
    const loanOutstandingAmount = loanOutstanding ?? vendorPaymentDetails?.loanOutstanding;

    const refundDetails = {
        
        refundApplicationDate: new Date(applicationDate),
        batchStartDate : new Date(batchStartDate),
        batchEndDate : new Date(batchEndDate),
        isLoanCase,
        preClosureReferenceNumber : loanLetterNumber,
        preClosureReferenceDate : loanLetterDate ? new Date(loanLetterDate) : '',
        loanOutstanding : loanOutstandingAmount,
        refundNumber,
        refundCreationDate: createdOn
    }

    const refundItemDetails = {
        subOrderType,
        regRefundAmount,
        admRefundAmount,
        cmprRefundAmount,
        refundAmount,
        rectificationReason,
        orderReasonId,
        remarks: remark,
        parentAttachmentKey,
        loanAttachmentKey,
        payableToParent: studentPaymentDetails?.refundAmount ?? 0,
        payableToVendor: vendorPaymentDetails?.refundAmount ?? 0
    }

    let studentAccountDetails, vendorAccountDetails;

    {
        const { beneficiaryName, bankKey, paymentModeNumber, accountType, ifscCode, bankMasterId, paymentModeType, supportingDocument, paymentModeDate} = studentPaymentDetails ?? {};
        studentAccountDetails = {
             beneficiaryName, 
             bankKey, 
             accountNumber: paymentModeNumber, 
             beneficiaryType: 'Student',
             bankAccountType : accountType,
             accountType : 'Primary',
             ifscCode, 
             bankMasterId,
             bankStatus : 'ACTIVE',
             id : paymentModeNumber,

             //cheque details fields
             paymentModeType,
             attachmentKey : supportingDocument,
             paymentModeDate
            };
    }

    {
        const { beneficiaryName, bankKey, paymentModeNumber, accountType, ifscCode, bankMasterId } = vendorPaymentDetails ?? {};
        vendorAccountDetails = {
             beneficiaryName, 
             bankKey, 
             accountNumber: paymentModeNumber, 
             beneficiaryType: 'Third Party',
             accountType, 
             ifscCode, 
             bankMasterId,
             bankStatus : 'ACTIVE'
            };
    }

    const refundAccountDetails = [
        studentAccountDetails,
        ...(isLoanCase ? [vendorAccountDetails] : [])
    ]

    // const {dlpFeeSummaryBreakup = [] } = dlpFeeSummaryDto;
    const isDLPCase = academicCareer === 'DLP';

    const {
        courseFee,
        regFee,
        dlpCourseFee,
        dlpCourseFeePaid,
        totalUtilisedAmount,
        netRefundableAmount,
    } = dlpFeeSummaryBreakUpList?.[0] ?? {};


    const dlpWithdrawalRefundDetails = {
        // ...dlpFeeSummaryDto,
        isDLPCase,
        courseFee,
        regFee,
        dlpCourseFee,
        dlpCourseFeePaid,
        totalUtilisedAmount,
        netRefundableAmount,
        ...(dlpFeeSummaryBreakUpList?.reduce((acc, curr) => {
            return {
                ...acc,
                ...(curr?.items ? { [curr.items]: { ...curr } } : {})
            }
        }, {}))
    }

    return { 
        refundDetails, 
        refundItemDetails, 
        refundAccountDetails, 
        withdrawalFeeSummary, 
        dlpWithdrawalRefundDetails
    };

}

export const useAutoFillRefundDetailsForRefundEdit = ({ //mimicking the user behaviour of filling refund details 
    setSelectedRefundItems,
    setRefundDetailsForm,
    selectedRefundItems,
    // setPayableRefundInfo,
    // setLoading,
    // handleRefundDetailsForm,
    getRefundInfoClickHandler
}) => {

    const { values, params } = useWizard();

    const { mode } = params;
    const { raisedRefundDetails, multiTypeRefundUtils, multiTypeRefundStep2Data, selectedStudent } = values;
    const { additionalStudentDetails } = multiTypeRefundStep2Data;
    const { refundReasons } = multiTypeRefundUtils;

    const init = () => {
        const { refundDetails, refundItemDetails, dlpWithdrawalRefundDetails } = segregateRefundDetails(raisedRefundDetails);
        const { subOrderType, orderReasonId } = refundItemDetails;
        const subOrderTypeReasons = refundReasons[subOrderType];

        // const studentDetails = {
        //     ...selectedStudent,
        //     ...additionalStudentDetails
        // }

        setSelectedRefundItems([subOrderType]); //3. selects the refund item

        setRefundDetailsForm({
            ...refundDetails, //1. fills refund details form 
             //4. fills the refund item form
            [subOrderType]: {
                ...refundItemDetails,
                cmpConcession:refundItemDetails?.cmprRefundAmount,
                admissionConcession:  refundItemDetails?.admRefundAmount||0,
                registrationConcession:refundItemDetails?.regRefundAmount||0,
                reason: subOrderTypeReasons?.find(reason => reason?.value === orderReasonId)
            },
            dlpWithdrawalRefundDetails
        });
        //2. clicks on "Get Refund Info" button
        // getRefundInfoClickHandler({ setLoading, setPayableRefundInfo, studentDetails, refundDetailsForm: refundDetails, handleRefundDetailsForm })
        getRefundInfoClickHandler({ form: refundDetails, resetRefundItemsForm: false });

    }

    useEffect(() => {
        mode === 'edit'
            && selectedRefundItems?.length === 0 // to ensure that the init function runs only once, the init function sets the selectedRefundItems and the user cannot deSelect a refund item in edit mode
            && refundReasons
            && additionalStudentDetails
            && init();
    }, [refundReasons, additionalStudentDetails, selectedRefundItems])

}


export const createLoanForeclosureRequest = (reqObj) => {
    const { studentDetails, refundDetailsForm, refundSubType, buList } = reqObj || {}
    const { studentLoanDetails = {}, coursePricingDetails = {}, studentChargesDetails = {} } = studentDetails;
    const { value } = studentLoanDetails?.loanScheme || {};
    const vendorName =studentLoanDetails?.loanScheme?.vendorName || ''
    const [tenor, advanceEmi] = value.split("/");
    const buDesc = (buList.find((item) => item?.label == studentChargesDetails?.businessAreaValue))?.businessAreaDesc
    return {
        studentName: studentChargesDetails?.studentName,
        psId: studentChargesDetails?.psid,
        parentName: studentChargesDetails?.studentFatherName,
        branchName: buDesc,
        vendorName,
        copies: [
            { copyLabel: "AESL Copy" },
            { copyLabel: "Parent Copy" },
            { copyLabel: `${vendorName} Copy` }
        ],
        foreclosureDetails: [
            { sr: "A", particular: "LAN NO", detail: "" },
            { sr: "B", particular: `${vendorName} PARTNER CODE`, detail: "" },
            { sr: "C", particular: "GROSS LOAN AMOUNT", detail: studentLoanDetails?.loanAmount },
            { sr: "D", particular: "DOWN PAYMENT", detail: studentLoanDetails?.totalUpfrontPaymentByParent },
            { sr: "E", particular: "NET LOAN AMOUNT", detail: studentLoanDetails?.netLoanAmount },
            { sr: "F", particular: "TENOR", detail: tenor },
            { sr: "G", particular: "ADVANCE EMI PAID", detail: advanceEmi },
            { sr: "H", particular: "DATE OF ADMISSION", detail: moment(studentChargesDetails?.createdOn).format('DD-MM-YYYY') },
            { sr: "I", particular: "DATE OF COMMENCEMENT OF COURSE", detail: moment(coursePricingDetails?.courseStartDate).format('DD-MM-YYYY') },
            { sr: "J", particular: "DATE OF CANCELLATION", detail: moment(refundDetailsForm?.refundApplicationDate).format('DD-MM-YYYY') },
            { sr: "K", particular: `TOTAL FORECLOSURE AMT TO BE PAID TO ${vendorName}`, detail: refundDetailsForm?.loanOutstanding },
            { sr: "L", particular: `AMT TO BE PAID BY PARTNER TO ${vendorName} (Refund)`, detail: refundDetailsForm?.[refundSubType]?.payableToVendor },
            { sr: "M", particular: `BALANCE AMT PAYABLE BY CUSTOMER TO ${vendorName}`, detail: Number(refundDetailsForm?.loanOutstanding || 0) - Number(refundDetailsForm?.[refundSubType]?.payableToVendor || 0) },
            { sr: "N", particular: "NEFT/RTGS NO", detail: "" },
            { sr: "O", particular: "NEFT/RTGS DATE", detail: "" },
            { sr: "P", particular: "CUSTOMER EMAIL ID", detail: studentChargesDetails?.email }
        ]
    };
}

export const createParentConsentRequest = (reqObj) => {
    const { buList, studentDetails, feeSummaryDetail, refundDetailsForm, refundSubType, useDetails } = reqObj || {}
    const { studentLoanDetails = {}, coursePricingDetails = {}, studentChargesDetails = {}, studentAccountDetails = {}, loanVendorAccountDetails = {} } = studentDetails;
    const primaryBankAccountDetails = studentAccountDetails.find(item => (item?.accountType == "Primary" && item?.bankStatus == "ACTIVE"))

    const { totalPaidAmount, totalGrossAmount } = calculateGrossAndPaidForItemType(feeSummaryDetail?.feeSummaryDTOList, '04')

    const buDesc = (buList.find((item) => item?.label == studentChargesDetails?.businessAreaValue))?.businessAreaDesc

    return {
        title: "Refund Form - Aakash Institute",
        branchName: buDesc,
        applicationSubmissionDate: moment(refundDetailsForm?.refundApplicationDate).format('DD/MM/YYYY'),
        businessUnit: studentChargesDetails?.businessAreaValue,
        refundNo: "",
        studentName: studentChargesDetails?.studentName,
        psid: studentChargesDetails?.psid,
        fatherOrStudentName: studentChargesDetails?.studentFatherName,
        reasonOfRefund: refundDetailsForm?.[refundSubType]?.reason?.label,
        contactNumber: studentChargesDetails?.phoneNo,
        alternateNumber: studentChargesDetails?.alternatePhoneNo,
        emailAddress: studentChargesDetails?.email,
        payeeName: primaryBankAccountDetails?.beneficiaryName,
        bankAccountNumber: primaryBankAccountDetails?.accountNumber,
        ifscCode: primaryBankAccountDetails?.ifscCode,
        bankName: primaryBankAccountDetails?.bankKey,
        branchNameFull: primaryBankAccountDetails?.beneficiaryBranch,
        //   cancelledCheque: true,
        //   passbookAttached: false,
        //   relationship: "",
        commencement: {
            firstTerm: moment(coursePricingDetails?.firstYearStartDate).format('YYYY-MM-DD'),
            secondTerm: moment(coursePricingDetails?.secondYearStartDate).format('YYYY-MM-DD'),
        },
        courseName: coursePricingDetails?.courseDescription,
        ...mapFeeData(feeSummaryDetail?.feeSummaryDTOList ?? []),
        totalConcessionPercent: feeSummaryDetail?.concessionPercentage || 0
        ,
        calculation: {
            courseFee: coursePricingDetails?.finalAmount || 0,
            realizedCourseFee: feeSummaryDetail?.totalPaidRealized || 0,
            examTechFee: totalGrossAmount || 0,
            realizedExamTechFee: totalPaidAmount || 0,
            totalCourseDays: getTotalCourseDays(coursePricingDetails?.courseEndDate, refundDetailsForm?.batchStartDate),
        },
        doId: studentLoanDetails?.doId,
        loanOSAmount: refundDetailsForm?.loanOutstanding || 0,
        loanReferenceNumber: refundDetailsForm?.preClosureReferenceNumber || 0,
        remark: refundDetailsForm?.[refundSubType]?.remarks
        ,
        //   digitalConversionAttempted: true,
        //   digitalConversionRemarks:
        //     "Attempted conversion to digital mode but parent declined",
        vendorName: studentLoanDetails?.loanScheme?.vendorName || 'loan vendor',
        refundToVendor: refundDetailsForm?.[refundSubType]?.payableToVendor || 0,
        refundToParent: refundDetailsForm?.[refundSubType]?.payableToParent || 0,
        amtToBeRefunded: Number(refundDetailsForm?.[refundSubType]?.payableToVendor || 0) + Number(refundDetailsForm?.[refundSubType]?.payableToParent || 0),
        processedByEmp: `${useDetails?.firstName || ''} ${useDetails?.lastName || ''}`,
    };

}

export const getTotalCourseDays = (end, start) => {

    if (!start || !end) return 0;

    const startDate = moment(start).utc().startOf("day");
    const endDate = moment(end).utc().startOf("day");

    return endDate.diff(startDate, "days") + 1;
};

export const fetchSupportingDocDetails = async (applicationId, businessAreaDispValue) => {
    const res = await fetchStudentSummary(applicationId, businessAreaDispValue);
    return res?.data
}
function mapFeeData(feeList) {
    const data = {
        paymentDate: {
            lumpSum1: "N/A",
            lumpSum2: "N/A",
            registrationDate: "N/A",
            startupAndDigitalDate: "N/A",
            installment1Date: "N/A",
            installment2Date: "N/A",
            installment3Date: "N/A",
            installment4Date: "N/A",
            installment5Date: "N/A",
            installment6Date: "N/A",
        },
        amounts: {
            registration: "N/A",
            startupAndDigital: "N/A",
            installment1: "N/A",
            installment2: "N/A",
            installment3: "N/A",
            installment4: "N/A",
            installment5: "N/A",
            installment6: "N/A",
        },
    };

    const formatAmount = (amt) => (amt && amt > 0 ? `₹${amt}` : "N/A");
    const formatDate = d => (d ? moment(d).format('DD-MMM-YYYY') : 'N/A');

    feeList.forEach((item) => {
        const desc = item.description.toLowerCase();
        const paid = item.paidAmount;
        const paymentDate = item.dateOfPayment;

        if (desc.includes("registration")) {
            data.amounts.registration = formatAmount(paid);
            data.paymentDate.registrationDate = formatDate(paymentDate)
        }

        if (desc.includes("admission kit")) {
            data.amounts.startupAndDigital = formatAmount(paid);
            data.paymentDate.startupAndDigitalDate = formatDate(paymentDate)
        }

        const instMatch = desc.match(/(\d+)(st|nd|rd|th) installment/);
        if (instMatch) {
            const instNumber = instMatch[1];
            data.amounts[`installment${instNumber}`] = formatAmount(paid);
            data.paymentDate[`installment${instNumber}Date`] = formatDate(paymentDate);
        }
    });

    return data;
}

export const downloadDocument = async ({ templateData = [], getPdf = true, templateName = '', uploadUrl = '' }) => {

    // call htmlToPdf API
    try {
        const reqObj = {
            templateName,
            uploadUrl,
            getPdf,
            templateData
        };

        const response = await fetchAllPostPromisedData(endpoint.createPdf, reqObj);

        if (response?.code === 200) {
            const pdfBuffer = response.pdfFile.data;

            const blob = new Blob([new Uint8Array(pdfBuffer)], {
                type: "application/pdf",
            });
            const url = URL.createObjectURL(blob);
            window.open(url);
        }
    }
    catch (err) {
        console.log(err)
    }
};

export const getSupportingDoc = async (useDetails, studentDetails, buList, refundDetailsForm, refundSubType, isLoanCase, setLoading) => {
    try {
        setLoading(true)
        const { applicationId, businessAreaValue } = studentDetails?.studentChargesDetails || {}
        const feeSummaryDetail = await fetchSupportingDocDetails(applicationId, businessAreaValue)
        const parentConsentReq = createParentConsentRequest({ useDetails, buList, feeSummaryDetail, studentDetails, refundDetailsForm, refundSubType })
        if (isLoanCase) {
            const loanForeclosureReq = createLoanForeclosureRequest({ useDetails, buList, feeSummaryDetail, studentDetails, refundDetailsForm, refundSubType })
            await Promise.all([
                downloadDocument({ templateData: parentConsentReq, templateName: 'refundParentConsentForm', }),
                downloadDocument({ templateData: loanForeclosureReq, templateName: 'refundLoanForeclosure', }),
            ])
        }
        else
            downloadDocument({ templateData: parentConsentReq, templateName: 'refundParentConsentForm', });
    }
    catch (err) {
        console.error('Failed in downloading suppporting Doc: ', err)
    }
    finally {
        setLoading(false)
    }
}

export const calculateGrossAndPaidForItemType = (data = [], lastTwoItemTypeChar) => {
    let totalPaidAmount = 0;
    let totalGrossAmount = 0;

    data.forEach(item => {
        (item.feeBreakupDTOList || []).forEach(fee => {
            if (fee.itemType?.toString().endsWith(lastTwoItemTypeChar)) {
                totalPaidAmount += Number(fee.paidAmount || 0);
                totalGrossAmount += Number(fee.grossAmount || 0);
            }
        });
    });

    return { totalPaidAmount, totalGrossAmount };
};

export const useCheckForRefundEdit = () => {
    const {params} = useWizard();
    return params?.mode === 'edit';
}


